export default "__VITE_ASSET__CVi7ybXf__"